function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.70711,4.29289a1.0002,1.0002,0,0,1,.08319,1.32l-.08319.09421L12,14.41421,7.29289,9.70711a1.00006,1.00006,0,0,1,1.32-1.49741l.09421.08319L12,11.585l7.29289-7.29211A1,1,0,0,1,20.70711,4.29289ZM11,4a1,1,0,0,1,.11662,1.99327L11,6H5V18H17V12a1.00015,1.00015,0,0,1,.88338-.99327L18,11a1.00015,1.00015,0,0,1,.99327.88338L19,12v8H3V4Z"
});

var SvgSettingsDone = function SvgSettingsDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-done.99d4ffe8.svg";
export { ForwardRef as ReactComponent };